<template>
    <ul class="img-picker-box clearfix">
        <li
            v-for="(item, index) in list"
            :key="index"
            class="img-picker-item"
            :class="getItemClass(item)"
            @click="handlerSelect(item)"
        >
            <imgItem :item="item" :selected="selected" />
        </li>
    </ul>
</template>

<script>
import imgItem from './img-item';

export default {
    name: 'ImgPicker',
    components: {
        imgItem
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        selected: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        handlerSelect(item) {
            if (item.imgLoadError) return;
            this.$emit('handlerSelected', item);
        },
        getItemClass(item) {
            if (item.imgLoadError) {
                return 'error';
            }

            return item.id === this.selected.id ? 'selected' : '';
        }
    }
};
</script>

<style>
.img-picker-box .img-picker-item {
    float: left;
    margin: 0;
    width: 136px;
    height: 136px;
    background-color: transparent;
    cursor: pointer;
}

.img-picker-box .img-picker-item.selected .reply-img-item,
.img-picker-box .img-picker-item:hover .reply-img-item {
    border-color: #0067ed;
}

.img-picker-box .img-picker-item.error:hover .reply-img-item {
    border-color: #edeff2;
}

.img-picker-box .img-picker-item.error {
    cursor: not-allowed;
}

.img-picker-box .img-picker-item.error .img {
    background: #e1e3e5
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAzCAMAAADvo9thAAAByFBMVEW0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t7+0t79W8E2XAAAAl3RSTlMAAQIDBAUGBwgJCgwNDg8QERIZGhscHSEjJCgpKjEyNDc4PD0+P0BBQkNESktMTU5TVFZXWl5gY2RmZ2hpa3BxcnN0dXZ4e3yBgoSFhoiJi42Oj5CSlZaXmZqbnJ+go6aoqaqtrq+wsbO0tba5uru8vb6/wMPFxsjJyszNztfZ3N7f5efo6err7O/w8fLz9PX29/n7/P3++uCUAgAAAphJREFUSMeN1vk7VGEYxvF7GBLKTsWkLClbJVsLNUgLSpItSkrJFlGi7EsmSpbx/Xf7YSaGWc77/PS+95nPdc55rvea80j+FZXn7BydmZubGe2syYuSQcWWj2zjU9sj5bEWJKV1C7/aak0JQWKad7y/cy/OfPo0s+j2bneaY4KZgiUA9oadmSe9b5fpHN4DYKkgILE37QOs1CUezZPqVgD2m+z+JnoAYNMZoFtRzt8AA9HHL5z+CjCYFPjBkwYBvpw+mkaOAe77tmCva6sHGIs8EvYAOzeC9zX8NQA9vlklsHfV0kDlYXZmC7hjZd4DW2cPwiGg28rcUzcw9D8sBhaiLY2iF4BCb/rdZx3CSEXAN096GRg3MdJnIE+S9Aa4YmSUD7ySpJi/MGtmpDn4E+ttQ72hUT1QLKkFOGdodA54Lmkalk2NtAzTkjbgo7HRB9iUkoGnxkZPgGRlAtXGRtVApi4BFcZGFUCuCoFSY6NSoFDZwE1jo1tAlhxAnbFRDeBQAtBubNQOJEhrx894KKNxWJM0ARvhfuZukEPyCyYkPQQuGhpdAB5JygGeGRq1ALmSIn7Cit3M2Fdh1S5JL4AyI6MyoEWSlOGG2XATEz4L+xme9VvvX6WV0W3gnXftcIMr1dqkusB9/v+uE5g8YWXsk0DXwTZ+CVi0MGoDluIP99meD2tI8wDYy/FNaglx3iTJ1gBQ639v+uOCmbh+gLZjadhLgIX8wCZ/AaArzO/+jQD0pfuT9D4AGgN9ka+5ANz9RRG+aURRvxvAdT3wQ6SNeHq43leVm2iTbIm5VX3rnmw0LWiPSuZ9xiif0Wq+JNQUZi/94T+F/Si1Ww18jsdTu4dgd6rRIaOKzapo6Ojt7WioyDoV6Po/+IyUVJxDfyEAAAAASUVORK5CYII=')
        39px 20px no-repeat;
}
</style>
